import { OrderDto } from "../generated/print-client";
import { getRestaurantTypeLabel } from "../util/utils";

export function logSignUp(internalId: number, type: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "signup",
    account_id: internalId,
    account_category: getRestaurantTypeLabel(type)
  });
}


export function logSignIn(memberId: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "signin",
    account_id: memberId,
  });
}

export function updateMemberStatus(memberId: number, plan: string, status: string, term: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    account_id: memberId,
    logged_in: "yes",
    subscription_plan: plan,
    subscription_status: status,
    subscription_term: term,
  });
}

export function logCheckout(order: OrderDto) {
  window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: "purchase",
    ecommerce: {
      transaction_id: order.id,
      affiliation: "MustHaveMenus",
      value: order.subtotal,
      tax: order.tax,
      shipping: order.shipping,
      currency: "USD",
      items: order.items?.map(item => {
        return {
          item_id: item.id,
          item_name: item.designName,
          affiliation: "MustHaveMenus",
          item_category: item.paperSize,
          item_category2: item.paperType,
          item_category3: item.pagination,
          price: item.price,
          quantity: item.quantity
        }
      })
    }
  });
}

export function logViewCart(order: OrderDto) {
  window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: "view_cart",
    ecommerce: {
      currency: "USD",
      value: order.total,
      items: order.items?.map(item => {
        return {
          item_id: item.id,
          item_name: item.designName,
          affiliation: "MustHaveMenus",
          item_category: item.paperSize,
          item_category2: item.paperType,
          item_category3: item.pagination,
          price: item.price,
          quantity: item.quantity
        }
      })
    }
  });
}

export function logRemoveFromCart(order: OrderDto) {
  window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: "remove_from_cart",
    ecommerce: {
      currency: "USD",
      value: order.total,
      items: order.items?.map(item => {
        return {
          item_id: item.id,
          item_name: item.designName,
          affiliation: "MustHaveMenus",
          item_category: item.paperSize,
          item_category2: item.paperType,
          item_category3: item.pagination,
          price: item.price,
          quantity: item.quantity
        }
      })
    },
  });
}
